var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.closable)?_c('v-btn',{attrs:{"color":"secondary","rounded":"","depressed":"","x-small":"","loading":_vm.loading},on:{"click":function($event){return _vm.handleClose()}}},[_vm._v("Close Order")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }